import constants from "@/constants"


export default {
    state: {
        fileStatus: constants.FILE_STATUS,
        additionalStatus: constants.ADDITIONAL_STATUS,
        defaultFileStatus: constants.DEFAULT_FILE_STATUS,
        defaultAdditionalStatus: constants.DEFAULT_ADDITIONAL_STATUS,
    },
    getters: {
        FILE_STATUS: state => {return state.fileStatus},
        ADDITIONAL_STATUS: state => {return state.additionalStatus},
        DEFAULT_FILE_STATUS: state => {return state.defaultFileStatus},
        DEFAULT_ADDITIONAL_STATUS: state => {return state.defaultAdditionalStatus},
    },
    mutations: {

    },
    actions: {

    }
}